
export const ANALYZE_BEFORE_SCORES = [
    {
        scores: [17, 18, 19],
        title: '임차권 등기가 되어 있어요!',
        content: '이전에 살던 세입자가 보증금을 돌려받지 못하고 있는 상황이기 때문에 안전도 점수가 감점되었어요!',
    },
    {
        scores: [41, 42, 43],
        title: '시세 대비 근저당이 높아요!',
        content: '이 집은 시세 대비 높은 근저당 설정으로 인해 안전도 점수가 감점되었어요!<br/><br/>' +
            '높은 근저당은 집주인이 많은 빚을 가지고 있음을 의미합니다. 이런 상황에서 집이 경매로 넘어간다면, 집주인이 먼저 갚아야 할 빚 때문에 내 보증금을 완전히 돌려 받기 어려울 수 있어요.',
    },
    {
        scores: [51, 52, 53],
        title: '시세 대비 전세가가 높아요!',
        content: '이 집은 시세 대비 전세가가 높아 안전도 점수가 감점되었어요!<br/><br/>' +
            '이 집의 경우 예상 시세 대비 전세가가 높아 보증보험 가입이 어려워요. 보증보험 가입이 어려운 경우 나중에 집주인에게 문제가 생겨 집이 경매로 넘어가면 온전히 내 보증금을 돌려 받기 어려울 수 있어 주의가 필요합니다.',
    },
    {
        scores: [56],
        title: '이 집을 담보로 받은 빚이 있어요!',
        content: '이 집을 담보로 받은 빚이 있어 안전도 점수가 감점되었어요!<br/><br/>' +
            '이 집을 담보로 받은 빚이 많은 편은 아니지만 보증보험 가입이 어려울 수 있어 주의가 필요해요!',
    },
    {
        scores: [61, 62, 63],
        title: '이 집을 담보로 받은 빚이 있어요!',
        content: '이 집을 담보로 받은 빚이 있어 안전도 점수가 감점되었어요!<br/><br/>' +
            '이 집을 담보로 받은 빚이 많은 편은 아니지만 그래도 주의가 필요해요. 만약 집이 경매로 넘어간다면 내 보증금 보다 먼저 갚아야할 돈이 있기 때문에 보증금을 돌려 받는데 오래 걸리거나 보증금 일부를 돌려 받지 못할 수 있습니다.',
    }
]

export const ANALYZE_BEFORE_TERMS = [
    {
        term: '신탁등기',
        title: '신탁등기가 되어 있어요!',
        content: '현재 이 집의 소유자가 신탁회사로 되어 있어 안전도 점수가 감점되었습니다.<br/><br/>' +
            '신탁등기된 부동산 거래 시, ‘우선 수익자’와 ‘수탁자’의 동의 없이 계약하면 위험할 수 있습니다. 신탁원부 확인을 통해 임대차 계약 조항을 정확히 파악해야하며, 이렇지 않을 경우 법적 문제나 사기 피해에 노출될 위험이 있어 주의가 필요해요!',
    },
    {
        term: '위반건축물',
        title: '위반건축물인 집이에요!',
        content: '이 건물은 건축물대장상 위반건축물에 해당하기 때문에 안전도 점수가 감점되었어요!<br/><br/>' +
            '건축물대장상 위반건축물로 표기된 경우 보증보험 가입이 불가해요. 보증보험 가입이 안되는 경우 나중에 집이 경매로 넘어가거나 집주인에게 문제가 발생하면 보증금을 돌려 받는데 어려움이 있을 수 있어 주의가 필요해요.',
    },
    {
        term: '갑구위험',
        title: '$$danger$$ 설정된 집이에요!',
        content: '이 집에 \\danger\\ 설정 되어 안전도 점수가 감점되었어요. 이런 상황에서 계약할 경우 내 보증금을 돌려 받지 못할 확률이 높아 계약을 추천드리지 않아요!',
    },
    {
        term: '대지권미등기',
        title: '대지권이 등기되지 않았어요!',
        content: '이 집은 대지권 등기가 되어 있지 않아 안전도 점수가 감점되었어요.<br/><br/>' +
            '대지권이 등기되지 않은 상황에서는 보증보험 가입이 어려울 수 있어요. 보증보험 가입이 안되는 경우 나중에 집주인에게 문제가 발생하면 보증금을 돌려 받는데 어려움이 있을 수 있어 주의가 필요합니다.',
    },
    {
        term: '전월세신고이력',
        title: '악성임대인 신고가 있는 집주인이에요!',
        content: '현재 이 집의 소유자가 보증금 미반환으로 여러 차례 신고된 임대인이라 안전도 점수가 감점되었습니다. <br/><br/>' +
            ' 악성 임대인 명단에 오른 집주인의 경우, 현재는 문제가 없어 보여도 계약 후에 압류와 같은 권리관계 문제가 발생할 가능성이 높고, 보증보험 가입도 어려울 수 있어 주의가 필요해요.',
    },
    {
        term: '신축',
        title: '신축 건물에 해당해요!',
        content: '이 집의 경우 신축건물로 보증보험 가입이 어려울 수 있어 안전도 점수가 감점되었어요!<br/><br/>' +
            '신축건물의 경우 보증보험사에서 산정하는 시세가 있지 않기 때문에 원칙적으로 보증보험 가입이 어려워요. 하지만 감정평가를 통해 시세를 확인할 수 있다면 보증보험 가입이 가능할 수 있으니 집주인과 공인중개사에게 꼭 보증보험 가입이 가능한지 물어봐야 해요!',
    },
    {
        term: '공동담보여부',
        title: '공동담보가 있는 집이에요!',
        content: '현재 집주인이 공동담보를 받아 놓은 상황이라 안전도 점수가 감점되었습니다. <br/><br/>' +
            '공동담보란 집주인이 여러 집을 담보로 큰 금액의 대출을 받는 경우를 말합니다. 공동담보가 있는 경우 담보로 잡은 부동산 중 하나에 문제가 발생했을 때, 모든 담보물에 영향을 미치기 때문에 보증금 반환 과정이 복잡해질 수 있어요.',
    },
    {
        term: '압류이력',
        title: '압류 이력이 있는 집주인이에요!',
        content: '집주인에게 압류 이력이 있어 안전도 점수가 감점되었어요!<br/><br/>' +
            '압류는 집주인이 빚을 갚지 못하거나 세금을 내지 못했을때 발생해요. 따라서 이 집주인에게 압류가 있었다는 건 빚을 제때 갚지 못했거나 세금을 내지 못할 만큼 재정상태가 안좋았다고 예측해 볼 수 있어요. 만약 계약 이후에도 이런 일이 발생하면 보증금을 온전히 돌려 받기 어려울 수 있어 주의가 필요해요.',
    },
    {
        term: '임차권이력',
        title: '임차권 이력이 있는 집이에요!',
        content: '과거 집주인이 세입자에게 보증금을 돌려주지 않은 이력이 있어 안전도 점수가 감점되었어요!',
    },
    {
        term: '근린생활시설',
        title: '주거용 건물이 아니에요!',
        content: '이 집은 근린생활시설 용도이기 때문에 안전도 점수가 감점되었습니다. <br/><br/>' +
            '근린생활시설은 상업용 건축물로 분류되어 있어 보증보험 가입과 전세대출이 어려울 수 있습니다. 이런 경우 집이 만약 경매로 넘어가면 보증보험 가입이 되어있지 않아 보증금을 돌려 받기 어려울 수 있습니다. 또한 계약 종료 시점에 보증보험 가입이 안된다는 이유로 새로운 세입자가 쉽게 구해지지 않을 수 있어 주의가 필요합니다.',
    },
    {
        term: '생활형숙박시설',
        title: '주거용 건물이 아니에요!',
        content: '이 집은 생활형 숙박시설로 주거용 건물이 아니기 때문에 안전도 점수가 감점되었습니다. <br/><br/>' +
            '생활형 숙박시설의 경우 보증보험 가입과 전세대출이 어려울 수 있습니다. 이런 경우 집이 만약 경매로 넘어가면 보증보험 가입이 되어있지 않아 보증금을 돌려 받기 어려울 수 있습니다. 또한 계약 종료 시점에 보증보험 가입이 안된다는 이유로 새로운 세입자가 쉽게 구해지지 않을 수 있어 주의가 필요합니다.',
    },
    {
        term: '건축물용도',
        title: '주거용 건물이 아니에요!',
        content: '이 집은 주거용 건물이 아니기 때문에 안전도 점수가 감점되었습니다. <br/><br/>' +
            '주거용 건물이 아닌 경우 보증보험 가입과 전세대출이 어려울 수 있습니다. 이런 경우 집이 만약 경매로 넘어가면 보증보험 가입이 되어있지 않아 보증금을 돌려 받기 어려울 수 있습니다. 또한 계약 종료 시점에 보증보험 가입이 안된다는 이유로 새로운 세입자가 쉽게 구해지지 않을 수 있어 주의가 필요합니다.',
    },
    {
        term: '갑구이력',
        title: '$$danger$$ 이력이 있는 집이에요!',
        content: '이 집에 \\danger\\ 이력이 있어 안전도 점수가 감점되었어요. 지금 당장 위험한 상황은 아니지만 집주인의 재정상태가 좋지 않았거나 채무관계가 좋지 않았던 적이 있을 수 있어 주의가 필요해요!',
    },
]

export const ANALYZE_BEFORE_SAFE = [
    {
        title: '위험한 등기사항은 없어요!',
        content: '등기부등본을 분석했을때 위험한 사항은 없는 것으로 보여 안전도 점수가 높게 평가 되었어요!',
    },
    {
        title: '집주인의 세금 체납을 확인해 주세요!',
        content: '집주인의 세금 체납 문제는 등기부등본에 나타나지 않기 때문에 계약 전 꼭 집주인의 세금 체납을 확인해 보는 것을 추천드려요!',
    }
]


export const ANALYZE_AFTER_SCORES = [
    {
        scores: [17, 18, 19],
        title: '임차권 등기가 되어 있어요!',
        content: '이 집에 임차권 설정이 되어 있어 안전도 점수가 감점되었어요.<br/><br/>' +
            '이 집에 임차권 설정을 해두셨나요? 직접 설정한 임차권인데도 불구하고 집주인이 보증금을 계속해서 돌려주지 않는다면 보증금 반환 소송을 해야할 수 있어요. 만약 직접 설정한 임차권이 아니라면 이 건물에 살고 있는 세입자가 보증금을 돌려 받지 못하고 있는 상황이라 볼 수 있어 변호사와 상담을 받아 보는 것을 추천드립니다.',
    },
    {
        scores: [41, 42, 43],
        title: '시세 대비 근저당이 높아요!',
        content: '이 집은 시세 대비 높은 근저당 설정으로 인해 안전도 점수가 감점되었어요!<br/><br/>' +
            '높은 근저당은 집주인이 많은 빚을 가지고 있음을 의미합니다. 이런 상황에서 집이 경매로 넘어간다면, 집주인이 갚아야 할 빚 때문에 내 보증금을 완전히 돌려 받기 어려울 수 있어요.',
    },
    {
        scores: [51, 52, 53],
        title: '시세 대비 전세가가 높아요!',
        content: '이 집은 시세 대비 전세가가 높아 안전도 점수가 감점되었어요!<br/><br/>' +
            '이 집의 경우 예상 시세 대비 전세가가 높아 보증보험 가입이 어려워요. 보증보험 가입이 어려운 경우 뒤에 들어오는 세입자가 잘 구해지지 않을 수도 있어요. 만약 세입자가 구해지지 않는다면 내 보증금을 돌려 받는데 어려움이 있을 수 있어요. 따라서 계약 연장을 원하지 않는다면 새로 들어올 세입자를 미리 구해 놓는 것이 좋아요!',
    },
    {
        scores: [56],
        title: '이 집을 담보로 받은 빚이 있어요!',
        content: '이 집을 담보로 받은 빚이 있어 안전도 점수가 감점되었어요!<br/><br/>' +
            '이 집을 담보로 받은 빚이 많은 편은 아니지만 보증보험 가입이 불가능해요. 보증보험 가입이 어려운 경우 뒤에 들어오는 세입자가 잘 구해지지 않을 수도 있어요. 만약 세입자가 구해지지 않는다면 내 보증금을 돌려 받는데 어려움이 있을 수 있어요. 따라서 계약 연장을 원하지 않는다면 새로 들어올 세입자를 미리 구해 놓는 것이 좋아요!',
    },
    {
        scores: [61, 62, 63],
        title: '이 집을 담보로 받은 빚이 있어요!',
        content: '이 집을 담보로 받은 빚이 있어 안전도 점수가 감점되었어요!<br/><br/>' +
            '이 집을 담보로 받은 빚이 많은 편은 아니지만 그래도 주의가 필요해요. 만약 집주인이 추가적으로 빚을 받는다거나 압류와 같은 등기가 생기면 위험할 수 있어 주기적으로 등기부등본을 확인해 보는 것이 좋아요.',
    }
]

export const ANALYZE_AFTER_TERMS = [
    {
        term: '신탁등기',
        title: '신탁등기가 되어 있어요!',
        content: '현재 이 집의 소유자가 신탁회사로 되어 있어 안전도 점수가 감점되었습니다.<br/><br/>' +
            '신탁등기된 부동산 거래 시, ‘우선 수익자’와 ‘수탁자’의 동의 없이 계약하면 위험할 수 있어요. 만약 계약할 때 부터 신탁등기가 되어있었는데도 불구하고 신탁회사 동의 없이 임대차 계약을 했다면 법적 문제가 생길 수 있어 반드시 변호사와 상담을 받아보는 것을 추천드립니다.',
    },
    {
        term: '위반건축물',
        title: '위반건축물인 집이에요!',
        content: '이 건물은 건축물대장상 위반건축물에 해당하기 때문에 안전도 점수가 감점되었어요!',
    },
    {
        term: '갑구위험',
        title: '$$danger$$가 설정된 집이에요!',
        content: '이 집에 \\danger\\가 설정되어 안전도 점수가 감점되었어요. <br/><br/>' +
            '우선 \\danger\\가 설정된 이유가 무엇인지 파악해 보셔야 해요. 집주인과 연락이 된다면 \\danger\\가 왜 설정되었는지, 계약이 끝나는 날에 맞춰 보증금을 돌려줄 여력이 되는 지 물어보는 것이 중요합니다.<br/><br/>' +
            '만약 집주인과 연락이 되지 않는다면 변호사에게 법률 상담을 받아보는 것이 좋을 수 있어요. 변호사와의 상담을 통해 보증금 반환을 위한 소송 등 다양한 법적 대응 방안을 모색해 볼 수 있습니다.<br/><br/>' +
            '그리고 혹시 모르니 보증금 반환 문제에 대비한 계획도 세우는 게 좋아요. 만약 집주인의 재정적 상황이 불안정해서 보증금을 제때 돌려받을 수 없을 것 같다고 판단된다면 계약을 연장할지, 계약이 끝나는 날에 맞춰 이사 나갈지 미리 계획을 세워 두셔야 해요. 만약 이사를 가야 한다면 임차권 설정을 먼저 해 둬야 하기 때문에 계약이 끝나는 시점에 맞춰 빠르게 준비해 두는 것이 중요할 수 있어요!',
    },
    {
        term: '대지권미등기',
        title: '대지권이 등기되지 않았어요!',
        content: '이 집은 대지권 등기가 되어 있지 않아 안전도 점수가 감점되었어요.<br/><br/>' +
            '대지권 등기가 되어 있지 않아 현재 보증보험 가입을 하지 못하셨을 것으로 예상되는데요. 만약 이런 상황에서 집이 경매로 넘어가면 위험할 수 있어요. 특히 대지권 등기가 되지 않은 경우 일반 부동산 보다 경매로 집이 팔리지 않거나 매우 저렴한 금액에 경매로 넘어갈 수 있어 주의가 필요합니다.',
    },
    {
        term: '전월세신고이력',
        title: '악성임대인 신고가 있는 집주인이에요!',
        content: '현재 이 집의 소유자가 보증금 미반환으로 여러 차례 신고된 임대인이라 안전도 점수가 감점되었습니다. <br/><br/>' +
            '악성 임대인 명단에 오른 집주인의 경우 계약이 종료되기 전 압류와 같은 권리관계 문제가 발생하거나 갑자기 보증금을 돌려줄 수 없다고 통보 받는 등의 문제가 발생할 수 있어 주의가 필요해요.',
    },
    {
        term: '신축',
        title: '신축 건물에 해당해요!',
        content: '이 집의 경우 신축건물로 정확한 시세 예측이 어렵기 때문에 안전도 점수가 감점되었어요.<br/><br/>' +
            '신축 건물의 경우 공시지가, KB시세 등 공식적인 시세 산정 기준이 없기 때문에 보증보험 가입도 어려울 수 있어요. 그리고 신축 건물의 경우 시세 변동폭이 클 수 있기 때문에 계약 중에도 주기적으로 시세를 확인해 보는 것을 추천드립니다.',
    },
    {
        term: '공동담보여부',
        title: '공동담보가 있는 집이에요!',
        content: '현재 집주인이 공동담보를 받아 놓은 상황이라 안전도 점수가 감점되었습니다. <br/><br/>' +
            '공동담보란 집주인이 여러 집을 담보로 큰 금액의 대출을 받는 경우를 말합니다. 공동담보가 있는 경우 담보로 잡은 부동산 중 하나에 문제가 발생했을 때, 모든 담보물에 영향을 미치기 때문에 보증금 반환 과정이 복잡해질 수 있어요.',
    },
    {
        term: '압류이력',
        title: '압류 이력이 있는 집주인이에요!',
        content: '집주인에게 압류 이력이 있어 안전도 점수가 감점되었어요!<br/><br/>' +
            '압류는 집주인이 빚을 갚지 못하거나 세금을 내지 못했을때 발생해요. 따라서 이 집주인에게 압류가 있었다는 건 빚을 제때 갚지 못했거나 세금을 내지 못할 만큼 재정상태가 안좋았다고 예측해 볼 수 있어요. 만약 내가 사는 도중에도 이런 일이 발생하면 보증금을 온전히 돌려 받기 어려울 수 있어 주의가 필요해요.',
    },
    {
        term: '임차권이력',
        title: '임차권 이력이 있는 집이에요!',
        content: '과거 집주인이 세입자에게 보증금을 돌려주지 않은 이력이 있어 안전도 점수가 감점되었어요!',
    },
    {
        term: '근린생활시설',
        title: '주거용 건물이 아니에요!',
        content: '이 집은 근린생활시설 용도이기 때문에 안전도 점수가 감점되었습니다. <br/><br/>' +
            '근린생활시설은 상업용 건축물로 분류되어 있어 보증보험 가입과 전세대출이 어려울 수 있습니다. 이런 경우 집이 만약 경매로 넘어가면 보증보험 가입이 되어있지 않아 보증금을 돌려 받기 어려울 수 있습니다. 또한 계약 종료 시점에 보증보험 가입이 안된다는 이유로 새로운 세입자가 쉽게 구해지지 않을 수 있어 주의가 필요합니다.',
    },
    {
        term: '생활형숙박시설',
        title: '주거용 건물이 아니에요!',
        content: '이 집은 생활형 숙박시설로 주거용 건물이 아니기 때문에 안전도 점수가 감점되었습니다. <br/><br/>' +
            '생활형 숙박시설의 경우 보증보험 가입과 전세대출이 어려울 수 있습니다. 이런 경우 집이 만약 경매로 넘어가면 보증보험 가입이 되어있지 않아 보증금을 돌려 받기 어려울 수 있습니다. 또한 계약 종료 시점에 보증보험 가입이 안된다는 이유로 새로운 세입자가 쉽게 구해지지 않을 수 있어 주의가 필요합니다.',
    },
    {
        term: '건축물용도',
        title: '주거용 건물이 아니에요!',
        content: '이 집은 주거용 건물이 아니기 때문에 안전도 점수가 감점되었습니다. <br/><br/>' +
            '주거용 건물이 아닌 경우 보증보험 가입과 전세대출이 어려울 수 있습니다. 이런 경우 집이 만약 경매로 넘어가면 보증보험 가입이 되어있지 않아 보증금을 돌려 받기 어려울 수 있습니다. 또한 계약 종료 시점에 보증보험 가입이 안된다는 이유로 새로운 세입자가 쉽게 구해지지 않을 수 있어 주의가 필요합니다.',
    },
    {
        term: '갑구이력',
        title: '$$danger$$ 이력이 있는 집이에요!',
        content: '이 집에 \\danger\\ 이력이 있어 안전도 점수가 감점되었어요. 지금 당장 위험한 상황은 아니지만 집주인의 재정상태가 좋지 않았거나 채무관계가 좋지 않았을 수도 있어요. <br/><br/>' +
            '만약 내가 사는 도중에도 이런 일이 발생하면 보증금을 온전히 돌려 받기 어려울 수 있기 때문에 주의가 필요합니다.'
    },
]

export const ANALYZE_AFTER_SAFE = [
    {
        title: '위험한 등기사항은 없어요!',
        content: '등기부등본을 분석했을때 위험한 사항은 없는 것으로 보여 안전도 점수가 높게 평가 되었어요!',
    },
    {
        title: '등기부등본을 자주 확인해 주세요!',
        content: '이미 살고 있는 집이라면 계약이 끝날때 까지 내 보증금이 안전하게 보호될 수 있는지 주기적으로 확인해 보는 것이 좋습니다. 만약 등기부등본에 압류가 생기거나 없던 빚이 생긴다면 집주인과 빠르게 연락해 보는 것이 좋으니 등기부등본을 자주 확인해 주세요!',
    }
]